import { colors, radius } from '../../theme/tokens'
import { choice, choiceOn } from '../choice-look'

const font = "Poppins, 'Helvetica Neue', sans-serif"

export const styles = theme => ({
  title: {
    fontFamily: font,
    fontWeight: 500,
    fontSize: '0.75rem',
    lineHeight: 1,
    color: '#64748b',
    marginTop: 2,
    marginBottom: 6
  },
  group: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 8,
    '@media (min-width: 600px)': {
      gridTemplateColumns: 'repeat(auto-fit, minmax(96px, 1fr))'
    }
  },
  // The booking screen's one chosen look (components/choice-look.js), as
  // the day chips.
  option: {
    ...choice,
    fontFamily: font,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 2,
    padding: '8px 6px',
    minHeight: 48,
    borderRadius: radius.control,
    lineHeight: 1.1,
    '&:disabled': { opacity: 0.45, cursor: 'default' }
  },
  optionSelected: choiceOn,
  optionInvalid: {
    borderColor: colors.error
  },
  optionToday: {
    borderStyle: 'dashed'
  },
  optionLabel: {
    fontSize: 13,
    fontWeight: 600
  },
  optionSub: {
    fontSize: 11,
    color: colors.mute
  }
})
